export enum InspectionFilterType {
  personal = 300,
  order = 1100,
  searchText = 1200,
  contentType = 1300,
  status = 1400,
  inspectorInspections = 1700,
  productLine = 3300,
  localEntity = 3400,
  from = 3500,
  to = 3600,
  fst = 3700,
  equipmentNumber = 3800,
  equipmentType = 3900,
  applicationSubType = 4000,
  parent = 4100
}

export enum InspectionOrderField {
  ByName = 100,
  ByStartDate = 300,
  ByCustomer = 400,
  ByEquipmentType = 500,
  ByEquipmentNumber = 600,
  ByFST = 700,
  ByProgress = 800,
  ByOffline = 900,
  ByStatus = 1000
}

export class InspectionFilter {
  order?: InspectionOrderField;
  searchText?: string;
  status?: number;
  productLine?: string;
  localEntity?: string;
  from?: Date;
  to?: Date;
  fst?: string;
  equipmentNumber?: string;
  equipmentType?: string;
  applicationSubType?: number;
}
